// ToDo: WW-7459 Move to shared shadow folder
import styles from '../../../../../../erp/components/tab-panels/positions/components/new-position-button/NewPostitionButton.module.scss';

import AddIcon from '@mui/icons-material/Add';
import { Box, IconButton } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SplitButton } from '@work4all/components/lib/components/split-button/SplitButton';
import { Tooltip } from '@work4all/components/lib/components/tooltip/Tooltip';

import { useSetting } from '@work4all/data/lib/settings/use-setting';

import { Article } from '@work4all/models/lib/Classes/Article.entity';
import { AddServiceContractPosTypeOfPos } from '@work4all/models/lib/Enums/AddServiceContractPosTypeOfPos.enum';

import { serviceContractPinnedActions } from '../../../../../../../../../../settings/settings';
import { IEditTable } from '../edit-table/types';
import {
  usePositionTableActions,
  UsePositionTableActionsOptions,
} from '../hooks/use-position-table-actions';

import { PinnedItem } from './PinnedItem';

interface NewPostitionButtonProps {
  onAddSpecial: (
    positionType: AddServiceContractPosTypeOfPos,
    article?: Article
  ) => void;
  disabled: boolean;
  editTableRef?: React.RefObject<IEditTable>;
}

export const NewPostitionButton = (props: NewPostitionButtonProps) => {
  const { disabled } = props;
  const { t } = useTranslation();

  const actions = usePositionTableActions(
    props as unknown as UsePositionTableActionsOptions
  );

  const options = useMemo(() => {
    const first = actions[0];
    return [
      {
        id: first.actionKey,
        name: first.title,
        icon: <AddIcon />,
        onClick: first.onClick,
      },
      ...actions.map((action) => ({
        id: action.actionKey,
        name: action.title,
        sections: action.sections,
        icon: (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="1.5rem"
          >
            <action.IconComponent style={{ color: 'var(--text03)' }} />
          </Box>
        ),
        onClick: action.onClick,
        group: [AddServiceContractPosTypeOfPos.DEFAULT as string].includes(
          action.actionKey
        )
          ? ''
          : [
              AddServiceContractPosTypeOfPos.HEADLINE as string,
              AddServiceContractPosTypeOfPos.TEXTLINE as string,
            ].includes(action.actionKey)
          ? t('COMMON.FUNCTIONS')
          : '',
      })),
    ];
  }, [actions, t]);

  const settings = useSetting(serviceContractPinnedActions());

  return (
    <div className={styles.buttonContainer}>
      <SplitButton
        disabled={disabled}
        itemClassName={styles.itemClassName}
        hideGroupLabels
        hideSelection
        options={options}
        firstIsTitle
        onClick={(option, event) => {
          option.onClick(event);
        }}
        variant="outlined"
        renderItem={(option, opts) => (
          <PinnedItem
            renderPin={!(opts && opts.buttonGroup)}
            title={option.name}
            icon={option.icon}
            id={option.id}
          />
        )}
      />
      <div className={styles.iconButtons}>
        {actions
          .filter((x) => settings.value.includes(x.actionKey))
          .map((action) => {
            return (
              <Tooltip key={action.actionKey} title={action.title}>
                <IconButton color="primary" onClick={action.onClick}>
                  <action.IconComponent />
                </IconButton>
              </Tooltip>
            );
          })}
      </div>
    </div>
  );
};
